import React from "react"
import { TextFieldFields } from "./TextFieldFields"
import { DropdownFieldFields } from "./DropdownFieldFields"
import { useCommonFieldProps } from "./CommonFieldPropsContext"
import { CommonFieldFields } from "./CommonFieldFields"
import { useWatch, useFormContext } from "react-hook-form"

export const RenderSchemaField: React.FC = () => {
  /** Grab this schema field's info */
  const { field, index } = useCommonFieldProps()

  /** Watch the variant field to re-render if required */
  const { control } = useFormContext()
  const fieldVariant = useWatch({
    control,
    name: `fields[${index}].variant`,
    defaultValue: field.variant,
  })

  /** Return the relevant fields */
  switch (fieldVariant) {
    case "switch":
      return <CommonFieldFields />
    case "select":
      return <DropdownFieldFields />
    default:
      return <TextFieldFields />
  }
}
